import { Dialog, Transition } from "@headlessui/react";
import useAskPaperDrawer from "features/AskPaperDrawer/hooks/useAskPaperDrawer";
import { Fragment } from "react";
import AskPaper from "./components/AskPaper";

function AskPaperDrawer() {
  const { isAskPaperDrawerOpen, paperId, title, closeAskPaperDrawer } =
    useAskPaperDrawer();

  if (title === undefined || paperId === undefined) return null;

  return (
    <Transition.Root show={isAskPaperDrawerOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeAskPaperDrawer}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-[#20202066] transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="fixed inset-y-0 right-0 flex max-w-full pt-12 pointer-events-none xl">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-400"
                enterFrom="translate-y-full"
                enterTo="translate-y-0"
                leave="transform transition ease-in-out duration-400"
                leaveFrom="translate-y-0"
                leaveTo="translate-y-full"
              >
                <Dialog.Panel className="relative w-screen pointer-events-auto max-w-screen">
                  <div
                    data-testid="drawer"
                    className="flex flex-col h-full overflow-y-auto bg-bg-base border-t rounded-t-2xl"
                  >
                    <div className="relative flex-1 overflow-y-auto bg-bg-base">
                      <AskPaper
                        title={title}
                        paperId={paperId}
                        onClose={closeAskPaperDrawer}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default AskPaperDrawer;
